import React from 'react';
import { boolean, object, func } from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import PublicQuery from 'library/util/public-query';
import hasHoc from 'util/hoc/has-hoc';
import {
  searchWorkforceCentersQuery,
  parseQueryData,
} from 'apps/journey/components/workforce-center-map/queries/searchWorkforceCentersQuery';
import { MapAndPins } from 'apps/journey/components/workforce-center-map';

const WorkforceCenterMap = ({
  graph_data,
  graph_loading,
  handle_graph_loading,
  graph_update,
  handleUpdateFavoritedCallback,
  authorized,
  renderUPSLayout,
}) => {
  return graph_loading ? (
    handle_graph_loading()
  ) : (
    <MapAndPins
      handleUpdateFavoritedCallback={handleUpdateFavoritedCallback}
      handle_graph_loading={handle_graph_loading}
      graph_loading={graph_loading}
      graph_update={graph_update}
      graph_data={graph_data}
      authorized={authorized}
      renderUPSLayout={renderUPSLayout}
    />
  );
};

WorkforceCenterMap.propTypes = {
  graph_data: object,
  graph_update: func,
  handle_graph_loading: func,
  graph_loading: boolean,
  query: func,
  handleUpdateFavoritedCallback: func,
  authorized: boolean,
  renderUPSLayout: boolean,
};

WorkforceCenterMap.defaultProps = {
  handle_graph_loading: () => null,
  query: PublicQuery,
  handleUpdateFavoritedCallback: () => null,
};

WorkforceCenterMap.query = async (_cancelToken, props) =>
  await searchWorkforceCentersQuery(
    resolve(props, 'query', PublicQuery),
    resolve(props, 'authorized', false),
    {
      mapCenterCoordinates: '',
    }
  );

WorkforceCenterMap.parseQueryData = (props) => parseQueryData(props);

WorkforceCenterMap.hoc_list = ['withData', 'withQuery'];

export default hasHoc(WorkforceCenterMap);
